import StatisticDataSet from '@/vue-prop-types/Statistics/StatisticDataSet'

export default class StatisticSeries {
  get yAxisLabels() {
    return this.labels
  }

  constructor({ labels = [], dataSets = [], highlightContent = null } = {}) {
    this.dataSets = dataSets.map((set, i) => new StatisticDataSet({ ...set, id: i }))
    this.labels = labels
    this.highlight = highlightContent
  }

  ConvertToFormat(format) {
    this.dataSets.forEach((set) => set.convertToFormat(format))
  }
}
